import React from 'react'
import dataLayer from './dataLayer'

const AdobeDTMTag = (props) => {
  const dataLayerHtml = dataLayer
  return (
    <div className="AdobeDTMTag">
      <script
        id="dataLayer"
        dangerouslySetInnerHTML={{ // eslint-disable-line react/no-danger
          __html: dataLayerHtml,
        }}
      />
    </div>
  )
}

export default AdobeDTMTag
